import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme: { spacing } }) => css`
    padding: ${spacing.level6} ${spacing.level6} 0;
    gap: ${spacing.level2};
  `}

  @media (max-width: 768px) {
    ${({ theme: { spacing } }) => css`
      padding: ${spacing.level5} ${spacing.level4} 0;
    `}
  }
`;

export const Description = styled.p`
  font-size: 14px;
  margin: 0 0 4px;
  line-height: 1.4;

  ${({ theme: { colors } }) => css`
    color: ${colors.onSurfaceVariant};
  `}
`;
